"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boxPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const as = ['div', 'span'];
const displayValues = ['none', 'inline', 'inline-block', 'block'];
const boxPropDefs = {
    as: { type: 'enum', values: as, default: 'div' },
    asChild: index_js_1.asChildProp,
    display: {
        type: 'enum',
        className: 'rt-r-display',
        values: displayValues,
        default: undefined,
        responsive: true,
    },
};
exports.boxPropDefs = boxPropDefs;
//# sourceMappingURL=box.props.js.map